import { useTranslations } from "next-intl";
import { useCurrentUser } from "@hooks/use-current-user";

function DefaultPaymentMethod() {
  const t = useTranslations("common");

  const defaultPaymentMethod = useCurrentUser()?.default_payment_method;
  const paymentMethodHasMandate = ["paypal", "sepa_debit"].includes(defaultPaymentMethod?.type);

  const invalidWarning = () => {
    if (defaultPaymentMethod?.valid) return null;

    return (
      <p className="mb-0 mt-2 text-danger">
        {paymentMethodHasMandate
          ? t("payment_method.warning.invalid")
          : t("payment_method.warning.expired")}
      </p>
    );
  };

  const displayCreditCard = () => (
    <>
      <p className="mb-0 text-capitalize text-gray">
        {t.rich("payment_method.credit_card.last4", {
          brand: defaultPaymentMethod.brand,
          last4: defaultPaymentMethod.last4,
          span: (chunks) => <span className="text-dark">{chunks}</span>,
        })}
      </p>
      <p className="mb-0 text-gray">
        {t.rich("payment_method.credit_card.expiracy", {
          month: defaultPaymentMethod.exp_month,
          year: defaultPaymentMethod.exp_year,
          span: (chunks) => (
            <span className={defaultPaymentMethod.valid ? "text-dark" : "text-danger"}>
              {chunks}
            </span>
          ),
        })}
      </p>

      {invalidWarning()}
    </>
  );

  const displayPaypal = () => (
    <>
      <p className="mb-0">
        {t.rich("payment_method.paypal.owner", {
          payerEmail: defaultPaymentMethod.payer_email,
          span: (chunks) => <span className="text-dark">{chunks}</span>,
        })}
      </p>

      {invalidWarning()}
    </>
  );

  const displayWalletCreditCard = () => (
    <>
      <p className="mb-0">{t(`payment_method.${defaultPaymentMethod.type}`)}</p>
      {displayCreditCard()}
    </>
  );

  const displaySepaDebit = () => {
    const last4Sliced =
      defaultPaymentMethod.last4.slice(0, 1) + " " + defaultPaymentMethod.last4.slice(1, 4);

    return (
      <>
        <p className="mb-0 text-capitalize">
          {t.rich("payment_method.sepa_debit.iban", {
            bankCode: defaultPaymentMethod.bank_code,
            last4: last4Sliced,
            span: (chunks) => <span className="text-dark">{chunks}</span>,
          })}
        </p>

        {invalidWarning()}
      </>
    );
  };

  if (!defaultPaymentMethod) return null;

  switch (defaultPaymentMethod.type) {
    case "card":
      return displayCreditCard();
    case "paypal":
      return displayPaypal();
    case "google_pay":
      return displayWalletCreditCard();
    case "apple_pay":
      return displayWalletCreditCard();
    case "sepa_debit":
      return displaySepaDebit();
    default:
      return null;
  }
}

export default DefaultPaymentMethod;
